import React, { Component } from 'react';
import { Localization } from '../localization/index';
import { PakleanImages } from '../images/index';
import { Colors } from '../colors/index';

import Modal from 'react-modal'
import { ClipLoader } from 'react-spinners';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';




class DamagesScreen extends Component {



    state = {
        type: [
            {
                group: 'پوشاک',
                items: [
                    {
                        name: 'لباس اسکی شامل شلوار و کاپشن',
                        value: 2
                    },

                    {
                        name: 'دامن',
                        value: 2
                    },

                    {
                        name: 'لباس راحتی',
                        innerType: [
                            {
                                name: 'لباس راحتی ورزشی',
                                value: 2
                            },
                            {
                                name: 'لباس راحتی معمولی',
                                value: 3
                            },
                        ],
                    },

                    {
                        name: 'جوراب',
                        value: 1
                    },

                    {
                        name: 'کت اسپرت',
                        innerType: [
                            {
                                name: 'کتان',
                                value: 3
                            },
                            {
                                name: 'چرم یا جیر مصنوعی',
                                value: 3
                            },
                            {
                                name: 'پشمی',
                                value: 4
                            },
                        ],
                    },

                    {
                        name: 'کت وشلوار',
                        innerType: [
                            {
                                name: 'نخی و کتان',
                                value: 2
                            },
                            {
                                name: 'نخی تابستانه',
                                value: 3
                            },
                            {
                                name: 'چرم یا جیر مصنوعی',
                                value: 3
                            },
                            {
                                name: 'ابریشم',
                                value: 3
                            },
                            {
                                name: 'قابل شستشو',
                                value: 2
                            },
                            {
                                name: 'پشمی زمستانی',
                                value: 4
                            },
                        ],
                    },

                    {
                        name: 'پلیور',
                        value: 3
                    },

                    {
                        name: 'کروات',
                        value: 1
                    },

                    {
                        name: 'لباس زیر',
                        innerType: [
                            {
                                name: 'شورت',
                                value: 1
                            },
                            {
                                name: 'زیر پیراهنی',
                                value: 2
                            },
                            {
                                name: 'لباس پایه',
                                value: 1
                            },
                        ],
                    },

                    {
                        name: 'لباس فرم اداری',
                        value: 1
                    },

                    {
                        name: 'جلیقه',
                        value: 2
                    },

                    {
                        name: 'لباس حمام',
                        value: 2
                    },

                    {
                        name: 'حوله تن پوش',
                        innerType: [
                            {
                                name: 'سبک',
                                value: 2
                            },
                            {
                                name: 'سنگین',
                                value: 3
                            },
                            {
                                name: 'پشمی',
                                value: 3
                            },
                        ]
                    },

                    {
                        name: 'کت تک',
                        innerType: [
                            {
                                name: 'کتان',
                                value: 3
                            },
                            {
                                name: 'چرم یا جیر مصنوعی',
                                value: 3
                            },
                            {
                                name: 'پشمی',
                                value: 4
                            },
                        ]
                    },

                    {
                        name: 'کاپشن و ژاکت',
                        innerType: [
                            {
                                name: 'بچگانه',
                                value: 2
                            },
                            {
                                name: 'پنبه ای',
                                value: 3
                            },
                            {
                                name: 'پر',
                                value: 3
                            },
                            {
                                name: 'خزدار',
                                value: 5
                            },
                            {
                                name: 'خز مصنوعی یا جیر',
                                value: 3
                            },
                            {
                                name: 'چرم، جیر، مخمل',
                                value: 5
                            },
                            {
                                name: 'نایلونی',
                                value: 2
                            },
                            {
                                name: 'پشمی',
                                value: 4
                            },
                        ]
                    },

                    {
                        name: 'بلوز',
                        value: 3
                    },

                    {
                        name: 'ردا، عبا و قبا',
                        value: 6
                    },

                    {
                        name: 'لباس های زنانه',
                        innerType: [
                            {
                                name: 'معمولی',
                                value: 2
                            },
                            {
                                name: 'نیمه رسمی',
                                value: 3
                            },
                            {
                                name: 'ابریشمی',
                                value: 2
                            },
                        ]
                    },

                    {
                        name: 'لباس شب',
                        innerType: [
                            {
                                name: 'کارشده زیاد',
                                value: 2
                            },
                            {
                                name: 'کار شده متوسط',
                                value: 3
                            },
                        ]
                    },

                    {
                        name: 'لباس رسمی',
                        value: 5
                    },

                    {
                        name: 'دستکش',
                        innerType: [
                            {
                                name: 'پارچه ای',
                                value: 1
                            },
                            {
                                name: 'چرم',
                                value: 2
                            },
                        ]
                    },

                    {
                        name: 'بارانی و بادگیر',
                        innerType: [
                            {
                                name: 'با رویه پلاستیکی',
                                value: 2
                            },
                            {
                                name: 'فابریک',
                                value: 3
                            },
                            {
                                name: 'لاستیکی یا پلاستیکی',
                                value: 3
                            },
                        ]
                    },

                    {
                        name: 'پیراهن',
                        innerType: [
                            {
                                name: 'زنانه',
                                value: 2
                            },
                            {
                                name: 'اسپرت یا شومیز',
                                value: 2
                            },
                            {
                                name: 'پشمی یا ابریشمی',
                                value: 2
                            },
                        ],
                    },
                ]
            },

            {
                group: 'اقلام خانگی',
                items: [

                    {
                        name: 'روتختی',
                        value: 2
                    },
                    {
                        name: 'پتو',
                        innerType: [
                            {
                                name: 'پتوی مسافرتی',
                                value: 2
                            },
                            {
                                name: 'پتوی گلبافت',
                                value: 3
                            },
                            {
                                name: 'پتوی لایکو( پشمی)',
                                value: 3
                            },
                        ],
                    },
                    {
                        name: 'لحاف',
                        innerType: [
                            {
                                name: 'پر',
                                value: 5
                            },
                            {
                                name: 'پنبه ای',
                                value: 3
                            }
                        ],
                    },
                    {
                        name: 'پرده',
                        innerType: [
                            {
                                name: 'حریر',
                                value: 3
                            },
                            {
                                name: 'فایبر گلس',
                                value: 3
                            }
                        ],
                    },
                    {
                        name: 'دراپه',
                        innerType: [
                            {
                                name: 'کلفت',
                                value: 5
                            },
                            {
                                name: 'معمولی',
                                value: 4
                            },
                            {
                                name: 'حریر',
                                value: 3
                            },
                            {
                                name: 'فایبر گلس',
                                value: 4
                            }
                        ],
                    },
                    {
                        name: 'ملحفه و روبالشی',
                        value: 2
                    },
                    {
                        name: 'رومبلی',
                        value: 3
                    },
                    {
                        name: 'رومیزی',
                        innerType: [
                            {
                                name: 'ترمه و سرمه',
                                value: 5
                            },
                            {
                                name: 'سایر',
                                value: 2
                            },
                        ],
                    },
                    {
                        name: 'رویه مبل و صندلی',
                        value: 5
                    }
                ]

            }

        ],

        timePassed: undefined,

        buyPrice: undefined,
        calculatedPrice: undefined,

        quality: ['ضعیف', 'متوسط', 'عالی'],
        selectedQualityIndex: 0,



        selectedGroup: null,
        selectedGroupIndex: 0,

        selectedMainType: null,
        selectedMainTypeIndex: 0,

        selectedInnerType: null,
        selectedInnerTypeIndex: 0,

        selectedValue: 0


    }


    componentDidMount() {

        let types = [...this.state.type]

        for (let i = 0; i < types.length; i++) {
            let type = { ...types[i] }
            type.items.sort((a, b) => {
                return a.name.localeCompare(b.name)
            })

            for (let j = 0; j < type.items.length; j++) {
                let item = type.items[j]
                if (item.innerType) {
                    item.innerType.sort((a, b) => {
                        return a.name.localeCompare(b.name)
                    })
                }
            }

        }


        this.setState({
            type: types,

        }, () => {
            this.setState({
                selectedGroup: this.state.type[0],
                selectedMainType: this.state.type[0].items[0],
                selectedInnerType: this.state.type[0].items[0].innerType[0],
                selectedValue: this.state.type[0].items[0].innerType[0].value
            })
        })
    }



    handleOuterValue = (event) => {

        this.setState({
            selectedMainTypeIndex: event.target.value,
            selectedMainType: this.state.selectedGroup.items[event.target.value],
            selectedInnerTypeIndex: 0,
            selectedInnerType: null
        }, () => {

            if (this.state.selectedMainType.value) {
                this.setState({ selectedValue: this.state.selectedMainType.value },
                    () => {
                        console.log(this.state.selectedValue)
                    }
                )
            }else{
                this.setState({ selectedValue: this.state.selectedMainType.innerType[0].value },
                    () => {
                        console.log(this.state.selectedValue)
                    }
                )
            }
        });
    }



    handleInnerValue = (event) => {
        this.setState({
            selectedInnerTypeIndex: event.target.value,
            selectedInnerType: this.state.selectedMainType.innerType[event.target.value],
        }, () => {

            this.setState({ selectedValue: this.state.selectedInnerType.value },
                () => {
                    console.log(this.state.selectedValue)
                }
            )
        });

    }


    calculatePrice = () => {

        let value = this.state.selectedValue
        let price = this.state.buyPrice
        let time = this.state.timePassed
        let quality = this.state.selectedQualityIndex
        let result = undefined

        let multiplier = undefined

        if (value == 1) {

            if (time < 4) {
                multiplier = 1
            }

            else if (time < 7) {
                if (quality == 1 || quality == 2)
                    multiplier = 0.75
                else
                    multiplier = 0.6
            }

            else if (time < 9) {
                if (quality == 0)
                    multiplier = 0.45
                else if (quality == 1)
                    multiplier = 0.6
                else
                    multiplier = 0.7
            }

            else if (time < 11) {
                if (quality == 0)
                    multiplier = 0.3
                else if (quality == 1)
                    multiplier = 0.4
                else
                    multiplier = 0.5
            }

            else if (time < 13) {
                if (quality == 0)
                    multiplier = 0.15
                else if (quality == 1)
                    multiplier = 0.2
                else
                    multiplier = 0.3
            }

            else if (time >= 13) {
                if (quality == 0)
                    multiplier = 0.1
                else if (quality == 1)
                    multiplier = 0.15
                else
                    multiplier = 0.2
            }



        }

        else if (value == 2) {

            if (time < 4) {
                multiplier = 1
            }

            else if (time < 7) {
                if (quality == 1 || quality == 2)
                    multiplier = 0.75
                else
                    multiplier = 0.6
            }

            else if (time < 13) {

                if (quality == 0)
                    multiplier = 0.45
                else if (quality == 1)
                    multiplier = 0.6
                else
                    multiplier = 0.7
            }

            else if (time < 19) {
                if (quality == 0)
                    multiplier = 0.3
                else if (quality == 1)
                    multiplier = 0.4
                else
                    multiplier = 0.5
            }

            else if (time < 25) {
                if (quality == 0)
                    multiplier = 0.15
                else if (quality == 1)
                    multiplier = 0.2
                else
                    multiplier = 0.3
            }

            else if (time >= 25) {
                if (quality == 0)
                    multiplier = 0.1
                else if (quality == 1)
                    multiplier = 0.15
                else
                    multiplier = 0.2
            }



        }
        else if (value == 3) {


            if (time < 4) {
                multiplier = 1
            }

            else if (time < 10) {
                if (quality == 1 || quality == 2)
                    multiplier = 0.75
                else
                    multiplier = 0.6
            }

            else if (time < 19) {
                if (quality == 0)
                    multiplier = 0.45
                else if (quality == 1)
                    multiplier = 0.6
                else
                    multiplier = 0.7
            }

            else if (time < 28) {
                if (quality == 0)
                    multiplier = 0.3
                else if (quality == 1)
                    multiplier = 0.4
                else
                    multiplier = 0.5
            }

            else if (time < 37) {
                if (quality == 0)
                    multiplier = 0.15
                else if (quality == 1)
                    multiplier = 0.2
                else
                    multiplier = 0.3
            }

            else if (time >= 37) {
                if (quality == 0)
                    multiplier = 0.1
                else if (quality == 1)
                    multiplier = 0.15
                else
                    multiplier = 0.2
            }




        }
        else if (value == 4) {



            if (time < 4) {
                multiplier = 1
            }

            else if (time < 13) {
                if (quality == 1 || quality == 2)
                    multiplier = 0.75
                else
                    multiplier = 0.6
            }

            else if (time < 25) {
                if (quality == 0)
                    multiplier = 0.45
                else if (quality == 1)
                    multiplier = 0.6
                else
                    multiplier = 0.7
            }

            else if (time < 37) {
                if (quality == 0)
                    multiplier = 0.3
                else if (quality == 1)
                    multiplier = 0.4
                else
                    multiplier = 0.5
            }

            else if (time < 49) {
                if (quality == 0)
                    multiplier = 0.15
                else if (quality == 1)
                    multiplier = 0.2
                else
                    multiplier = 0.3
            }

            else if (time >= 49) {
                if (quality == 0)
                    multiplier = 0.1
                else if (quality == 1)
                    multiplier = 0.15
                else
                    multiplier = 0.2
            }



        }
        else if (value == 5) {



            if (time < 4) {
                multiplier = 1
            }

            else if (time < 7) {
                if (quality == 1 || quality == 2)
                    multiplier = 0.75
                else
                    multiplier = 0.6
            }

            else if (time < 16) {
                if (quality == 0)
                    multiplier = 0.45
                else if (quality == 1)
                    multiplier = 0.6
                else
                    multiplier = 0.7
            }

            else if (time < 31) {
                if (quality == 0)
                    multiplier = 0.3
                else if (quality == 1)
                    multiplier = 0.4
                else
                    multiplier = 0.5
            }

            else if (time < 61) {
                if (quality == 0)
                    multiplier = 0.15
                else if (quality == 1)
                    multiplier = 0.2
                else
                    multiplier = 0.3
            }

            else if (time >= 61) {
                if (quality == 0)
                    multiplier = 0.1
                else if (quality == 1)
                    multiplier = 0.15
                else
                    multiplier = 0.2
            }



        }
        else if (value == 6) {


            if (time < 12) {
                multiplier = 1
            }

            else if (time < 48) {
                if (quality == 1 || quality == 2)
                    multiplier = 0.75
                else
                    multiplier = 0.6
            }

            else if (time < 72) {
                if (quality == 0)
                    multiplier = 0.45
                else if (quality == 1)
                    multiplier = 0.6
                else
                    multiplier = 0.7
            }

            else if (time < 96) {
                if (quality == 0)
                    multiplier = 0.3
                else if (quality == 1)
                    multiplier = 0.4
                else
                    multiplier = 0.5
            }

            else if (time < 132) {
                if (quality == 0)
                    multiplier = 0.15
                else if (quality == 1)
                    multiplier = 0.2
                else
                    multiplier = 0.3
            }

            else if (time >= 132) {
                if (quality == 0)
                    multiplier = 0.1
                else if (quality == 1)
                    multiplier = 0.15
                else
                    multiplier = 0.2
            }

        }

        console.log('value is : ' + value)
        console.log('quality is : ' + quality)
        console.log('multiplier is :' + multiplier)

        result = price * multiplier
        this.setState({ calculatedPrice: result })

    }


    render() {
        return (

            <div style={styles.container}>
                <div style={styles.content}>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'column', width: '80%' }} >
                        <div style={{ width: '90%', display: 'flex', flexDirection: 'row-reverse', marginTop: 30, padding: 5, alignItems: 'center' }} >

                            <p style={{ width: 150 }} >نوع کالا: </p>
                            <select
                                value={this.state.selectedGroupIndex}
                                onChange={(event) => {
                                    this.setState({
                                        selectedGroupIndex: event.target.value,
                                        selectedGroup: this.state.type[event.target.value],
                                        selectedMainTypeIndex: 0,
                                        selectedMainType: this.state.type[event.target.value].items[0],
                                        selectedInnerTypeIndex: 0,
                                        selectedInnerType: this.state.type[event.target.value].items[0].innerType[0],
                                        selectedValue: this.state.type[event.target.value].items[0].innerType[0].value
                                    })
                                }}>

                                <option value={0}>پوشاک</option>
                                <option value={1}>اقلام خانگی</option>

                            </select>



                            {this.state.selectedGroup ?

                                <select value={this.state.selectedMainTypeIndex}
                                    onChange={this.handleOuterValue}>
                                    {
                                        this.state.selectedGroup.items.map((item, index) =>
                                            <option key={index} value={index}>{item.name}</option>)
                                    }

                                </select>

                                :

                                <div />

                            }


                            {this.state.selectedGroup && this.state.selectedMainType && this.state.selectedMainType.innerType ?

                                <select value={this.state.selectedInnerTypeIndex}
                                    onChange={this.handleInnerValue}>
                                    {
                                        this.state.selectedMainType.innerType.map((item, index) =>
                                            <option key={index} value={index}>{item.name}</option>)
                                    }
                                </select>
                                :
                                <div />
                            }

                        </div>

                        <div style={{ width: '90%', display: 'flex', flexDirection: 'row-reverse', padding: 5, alignItems: 'center', }} >
                            <p style={{ width: 150 }} >وضعیت: </p>

                            <select
                                value={this.state.selectedQualityIndex}
                                onChange={(event) => {
                                    this.setState({ selectedQualityIndex: event.target.value })
                                }}>

                                <option value={0}>{this.state.quality[0]}</option>
                                <option value={1}>{this.state.quality[1]}</option>
                                <option value={2}>{this.state.quality[2]}</option>

                            </select>
                        </div>


                        <div style={{ width: '90%', display: 'flex', flexDirection: 'column', }} >

                            <div style={{ flex: 1, display: 'flex', flexDirection: 'row-reverse', padding: 5, alignItems: 'center' }} >
                                <p style={{ width: 150 }} >مدت زمان خرید: </p>
                                <input
                                    type='number'
                                    style={{ textAlign: 'center', marginLeft: 10, marginRight: 5 }}
                                    onChange={(e) => { this.setState({ timePassed: e.target.value }) }}
                                />
                                <p >ماه</p>


                            </div>


                            <div style={{ flex: 1, display: 'flex', flexDirection: 'row-reverse', padding: 5, alignItems: 'center' }} >
                                <p style={{ width: 150 }} >قیمت خرید: </p>
                                <input
                                    type='number'
                                    style={{ textAlign: 'center', marginLeft: 10, marginRight: 5 }}
                                    onChange={(e) => { this.setState({ buyPrice: e.target.value }) }}
                                />
                                <p  >تومان</p>


                            </div>

                        </div>


                        <button style={{ alignSelf:'center', width:150, backgroundColor: 'green', padding: 10, color: 'white', border: '1px solid green', borderRadius: 5, margin: 50 }}
                            onClick={this.calculatePrice} >
                            محاسبه
                        </button>


                        <div style={{ display: 'flex', flexDirection: 'row-reverse', justifyContent:'center' }} >
                            <p>قیمت جایگزینی بر اساس شرایط کالا: </p>
                            <p style={{ borderBottom: '1px solid black', color: 'red', paddingLeft: 5, paddingRight: 5, marginLeft: 5, marginRight: 5 }} >{this.state.calculatedPrice}</p>
                            <p> تومان</p>

                        </div>

                    </div>
                </div>





                <ToastContainer
                    closeButton={false}
                    hideProgressBar
                    rtl
                    style={{ textAlign: 'center', color: 'black', }}
                    autoClose={2000}
                    pauseOnFocusLoss={false}
                    position="bottom-center" />


                <Modal
                    isOpen={this.state.isLoading}
                    style={styles.spinnerStyle} >
                    <div style={{
                        display: 'flex', justifyContent: 'center',
                        WebkitBoxPack: 'center', WebkitBoxPack: 'center', WebkitBoxAlign: 'center', alignItems: 'center', WebkitBoxAlign: 'center',
                    }}>
                        <ClipLoader
                            size={100}
                            color={Colors.SpinnerColor}
                            loading={this.state.isLoading}
                        />
                    </div>

                </Modal>

            </div >


        );
    }
}



export default DamagesScreen

const styles = {

    modalStyles: {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            padding: 0,
            transform: 'translate(-50%, -50%)'
        },
        overlay: {
            zIndex: 10,
        },
    },

    modalStylesNotComplete: {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            padding: 0,
            transform: 'translate(-50%, -50%)'
        },
        overlay: {
            zIndex: 10,
            backgroundColor: "rgba(0, 0, 0, 0.85)",
        },
    }
    ,
    spinnerStyle: {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            border: 'none',
            outline: 'none',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'transparent'
        },
        overlay: {
            zIndex: 10,
        },
    },

    content: {

        position: 'fixed',
        padding: 10,
        width: '100%',
        height: '100%',
        paddingRight: 100,
        display: 'flex',
        alignSelf: 'center',
        WebkitBoxOrient: 'vertical', flexDirection: 'column',
        alignItems: 'center', WebkitBoxAlign: 'center',
    },

    container: {

        display: '-webkit-box',
        display: '-moz-box',
        display: '-ms-flexbox',
        display: '-webkit-flex',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: 'auto',
        justifyContent: 'stretch',
        alignItems: 'flex-start',
        WebkitBoxOrient: 'vertical',
        WebkitBoxDirection: 'normal',
        WebkitFlexDirection: 'column',
        WebkitFlexGrow: 1,
        WebkitFlexShrink: 0,
        WebkitFlexBasis: 'auto',
        WebkitBoxPack: 'stretch',
        WebkitJustifyContent: 'stretch',
        WebkitBoxAlign: 'start',
        WebkitAlignItems: 'flex-start',

    },
};

